/**
 * Audio & Call control helpers for ACS Call object
 */

export const muteCall = async (call, upsertCallMap) => {
  if (!call || !call.acsCall) return;
  try {
    await call.acsCall.mute();
    upsertCallMap(call.id, {isMuted : true});
  } catch (e) {
    console.error("Failed to mute:", e);
  }
};

export const unmuteCall = async (call, upsertCallMap) => {
  if (!call || !call.acsCall) return;
  try {
    await call.acsCall.unmute();
    upsertCallMap(call.id, {isMuted : false});
  } catch (e) {
    console.error("Failed to unmute:", e);
  }
};

export const holdCall = async (call, upsertCallMap) => {
  if (!call || !call.acsCall) return;
  try {
    upsertCallMap(call.id, {isHold : true, holdedAt: Date.now()}); //do it at top else callstate changes first
    await call.acsCall.hold();
    //upsertCallMap(call.id, {isHold : true, holdedAt: Date.now()});
  } catch (e) {
    console.error("Failed to hold call:", e);
  }
};

export const resumeCall = async (call, upsertCallMap) => {
  if (!call || !call.acsCall) return;
  try {
    const holdDurTotalNew = call.holdDurationTotal + (Date.now() - call.holdedAt);
    await call.acsCall.resume();
    upsertCallMap(call.id, {isHold : false, holdDurationTotal: holdDurTotalNew, holdedAt: null}); 
  } catch (e) {
    console.error("Failed to resume call:", e);
  }
};
